<template>

	<div class="bg-gray rounded-xl py-3 px-3 pb-0 mt-3 min-h-60 overflow-clip cursor-pointer"
		>
		<div class="flex items-center">
			<h1 class="text-base font-bold">Meeting Attendance</h1>
			<div class="ml-auto">
				<b-dropdown variant="link" right toggle-class="text-decoration-none" no-caret>
					<template #button-content>
						<span class="flex item-center w-full">
							<span class="text-gray-1 text-xs">{{filterLabel}} </span> <church-icon
								class="!w-3 relative -top-1" icon="chevron-down" />
						</span>
					</template>

					<b-dropdown-item v-for="filter in dateFilter" :key="filter?.value" @click="() => filterBy = filter">
						{{filter?.label}}
					</b-dropdown-item>
                       
					
				</b-dropdown>
			</div>
		</div>

		<div class="px-3 py-4 bg-white space-y-4 rounded-xl" @click="$router.push({ name: 'adminAnalyticsAttendance' })">
			<div class="grid grid-cols-6 content-center ">
				<div class="col-span-2 text-right pr-3 text-sm text-gray-1">Total</div>
				<div class="col-span-3 flex items-center">
					<div class="w-full rounded-lg h-1 bg-gray-2 overflow-clip ">
						<div :style="{ width: overallAttendancePercentage?.percentage+'%' }" class="bg-green h-full rounded-lg"></div>
					</div>
				</div>
				<div class="text-right text-sm text-gray-1">{{overallAttendancePercentage?.percentage}}%</div>
			</div>
			<div class="grid grid-cols-6 content-center " v-for="(meeting) in meetingAttendancePercentage?.slice(0, showMore ? 9999 : 4)" :key="meeting?.meeting_id">
				<div class="col-span-2 text-right pr-3 text-sm text-gray-1">{{ meeting.meeting_name }}</div>
				<div class="col-span-3 flex items-center">
					<div class="w-full rounded-lg h-1 bg-gray-2 overflow-clip ">
						<div :style="{ width: meeting?.percentage+'%', backgroundColor : ColorUtils.randomColor() }"
							class=" h-full rounded-lg"></div>
					</div>
				</div>
				<div class="text-right text-sm text-gray-1">{{meeting?.percentage+'%'}}</div>
			</div>
		</div>

		<button v-if="meetingAttendancePercentage?.length > 4" @click="showMore = !showMore"
			class="text-center w-full mt-2.5 px-3 py-1.5 text-sm font-bold text-blue">
			<template v-if="showMore">
				Show less
			</template>
			<template v-else>
				+{{ meetingAttendancePercentage?.length - 4 || 0 }} ... See more
			</template>
		</button>
	</div>

</template>

<script setup>
import ColorUtils from '@/helpers/colorUtils';
import DateUtils from '@/helpers/dateUtls';
import NumberUtils from '@/helpers/NumberUtils';
import { dateFilter } from '@/helpers/staticVariables';
import {  defineProps, computed, ref } from 'vue';

/* =========== PROPS =========== */

const props = defineProps({
	meetings: {
		type: Array,
		default: () => []
	}
});

/* ============ STATES ========= */
const filterBy = ref(dateFilter[0]);
const showMore = ref(false);

/* =========== COMPUTED ======== */

/**
 * Filter label
 * thismonth = This Month
 * last6months = Last 6 Months
 * year = Year
 */
const filterLabel = computed(() => {
	return filterBy.value?.label
});



 /**
 * Get total attancce and percentage
 * get each meeting attendance and percientage
 * filter by filterBy
 * @returns {Object}
 * 
 */
const meetingAttendancePercentage = computed(() =>  {
	console.log('props.meetings', props.meetings)

	return [...props.meetings || []]
		.filter(m => m?.task_attendance)
		.filter(meeting => filterBy?.value?.value !== 'all' ? DateUtils.isSame({date: meeting?.meeting_date, compareDate : new Date(), unit : 'year', timeZone : null, dateOriginFormat : 'MM/DD/YYYY'}) : meeting) 
		.filter(meeting => {
			if(filterBy.value?.value == 'month') return  DateUtils.isSame({date: meeting?.meeting_date, compareDate : new Date(), unit : 'months', timeZone : null, dateOriginFormat : 'MM/DD/YYYY'})
			if(filterBy.value?.value == 'quarter') return DateUtils.dateDiff({startDate : meeting?.meeting_date, endDate : new Date(), unit : 'months', timeZone : null, startDateOriginFomat : 'MM/DD/YYYY'}) <= 3
			if(filterBy.value?.value == 'year') return DateUtils.isSame({date: meeting?.meeting_date, compareDate : new Date(), unit : 'years', timeZone : null, dateOriginFormat : 'MM/DD/YYYY'})
			if(filterBy.value?.value == 'all') return true

			return true;
		})
		.map(m => {
			const total = m.task_attendance?.length || 0;
			const attendance = m.task_attendance?.filter(a => a.is_completed) || [];
			const percentage = total > 0 ? (attendance.length / total) * 100 : 0;
			return {
				meeting_name : m.title,
				meeting_id : m.id,
				total      : total,
				percentage : NumberUtils.toFixed(percentage)
			}
		})
})

/**
 * overall attendance percentage
 */
const overallAttendancePercentage = computed(() => {
	const total = props.meetings?.length || 0;
	const attendance = props.meetings?.filter(m => m.task_attendance?.some?.(a => a.is_completed)) || [];
	const percentage = total > 0 ? (attendance.length / total) * 100 : 0;
	return {
		total      : total,
		percentage : NumberUtils.toFixed(percentage)
	}
})

</script>
